module.exports = __webpack_public_path__ + "img/bookkeeping.847b1ae4.svg";